module.exports = __webpack_public_path__ + "img/organizations-bg.18c8cf03.webp";